import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /code group. See http/payment.ts for conventions. */
export const AccessCodeParams = Schema.Struct({
    siteId: SiteId,
    itemKey: Schema.String
});
/**
 * Covers both branches: the resolved access code, and the "no site data"
 * fallback that answers `{ valid: false, message: '', code: {} }`.
 */
export const CodeResponse = Schema.Struct({
    code: Schema.Any,
    valid: Schema.optional(Schema.Boolean),
    message: Schema.optional(Schema.String)
});
export const ClubCodeParams = Schema.Struct({
    siteId: SiteId,
    code: Schema.String
});
export const ClubCodeResponse = Schema.Struct({
    valid: Schema.Boolean,
    message: Schema.String,
    code: Schema.Any
});
/**
 * Instruksjoner (eksternt) for the external access point of a booked slot,
 * for the ticket holder or site staff. Empty when the caller may not see
 * them or the slot has no external access point (D69).
 */
export const AccessInfoResponse = Schema.Struct({
    instructions: Schema.String
});
//# sourceMappingURL=code.js.map